import { render } from "./ChildOtherRecordList.vue?vue&type=template&id=4632bd92&ts=true"
import script from "./ChildOtherRecordList.vue?vue&type=script&lang=ts"
export * from "./ChildOtherRecordList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__